import { makeStyles } from '@material-ui/core';
import { backgroundColorLogin } from 'app/utils/coresUtil';

export const sessaoBloqueadaStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: backgroundColorLogin,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    padding: '1.6rem',
    [theme.breakpoints.up('sm')]: {
      padding: '3.2rem',
    },
  },
  card: {
    width: '100%',
    maxWidth: '38.4rem',
  },
  cardContent: {
    padding: '1.6rem',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    display: 'flex',
    [theme.breakpoints.up('sm')]: {
      padding: '2.4rem',
    },
    [theme.breakpoints.up('md')]: {
      padding: '3.2rem',
    },
  },
  icone: {
    justifyContent: 'center',
    display: 'flex',
    margin: '3.2rem',
    fontSize: '4.3rem',
  },

  linkVoltar: {
    textAlign: 'center',
  },
}));
